import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    cn,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@repo/shadcn';
import { Check, ChevronsUpDown } from 'lucide-react';
import * as React from 'react';

import { ProductDto } from '../../../../features/slice/products/product/product.schema';

// export type AutocompleteOption = {
//   value: string
//   label: string
// }

interface AutocompleteProps {
    options: ProductDto[];
    value: string;
    handleSelectedItemId: (id: string) => void;
    placeholder: string;
    isLoading: boolean;
    handleProductSearch: (value: string) => void;
}

export function ProductAutocomplete({
    options,
    value,
    placeholder,
    isLoading,
    handleSelectedItemId,
    handleProductSearch,
}: AutocompleteProps) {
    const [open, setOpen] = React.useState(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                >
                    <p className="w-full truncate text-left">
                        {value
                            ? options?.find(
                                  (product: any) => product.id === value,
                              )?.name
                            : `Select ${placeholder ?? 'medicine'}...`}
                    </p>
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="!bottom-0 w-[400px] p-0">
                <Command className=" bottom-0">
                    <CommandInput
                        onValueChange={handleProductSearch}
                        placeholder={`Search ${placeholder.toLowerCase()}...`}
                    />
                    <CommandList>
                        {isLoading ? (
                            'Loading....'
                        ) : (
                            <>
                                <CommandEmpty>
                                    No {placeholder.toLowerCase()} found.
                                </CommandEmpty>
                                <CommandGroup>
                                    {options.map((product: any) => (
                                        <CommandItem
                                            key={product.id}
                                            value={product.name}
                                            onSelect={() => {
                                                handleSelectedItemId(
                                                    product.id,
                                                ),
                                                    setOpen(!open);
                                            }}
                                        >
                                            <Check
                                                className={cn(
                                                    'mr-2 h-4 w-4',
                                                    value === product.id
                                                        ? 'opacity-100'
                                                        : 'opacity-0',
                                                )}
                                            />
                                            {product.name}
                                        </CommandItem>
                                    ))}
                                </CommandGroup>
                            </>
                        )}
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}

// export function ProductAutoComplete({
//   setValue,
//   value,
//   setSelectedProductData,
// }: any) {
//   const [open, setOpen] = React.useState(false);

//   const [searchTerm, setSearchTerm] = React.useState('');
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');

//   // Debounce effect to limit the API calls
//   React.useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedSearchTerm(searchTerm);
//     }, 500); // Adjust the debounce delay as needed (e.g., 300ms)

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [searchTerm]);

//   // Fetch products based on the debounced search term
//   const { data: searchData, isLoading } = useGetProductsWithVariationsQuery({
//     limit: 10,
//     page: 1,
//     search: debouncedSearchTerm ? debouncedSearchTerm : '',
//   });

//   const changeSelection = (currentValue: string) => {
//     setValue(currentValue);
//     const selectedProduct = searchData.data.find(
//       (product: any) => product.id === currentValue,
//     );
//     setSelectedProductData(selectedProduct);
//     setOpen(false);
//   };

//   const handleSearchInput = (value: string) => {
//     setSearchTerm(value);
//   };

//   if (isLoading) {
//     return 'Loading...';
//   }

//   return (
//     <Popover open={open} onOpenChange={setOpen}>
//       <PopoverTrigger asChild>
//         <Button
//           variant="outline"
//           role="combobox"
//           aria-expanded={open}
//           className=" w-full mt-1 overflow-hidden   justify-between truncate"
//         >
//           <p className='w-full truncate text-left'>
//             {value
//               ? searchData?.data.find((product: any) => product.id === value)
//                 ?.name
//               : 'Select medicine...'}
//           </p>
//           <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//         </Button>
//       </PopoverTrigger>
//       <PopoverContent className="w-full  p-0">
//         <Command>
//           <CommandInput
//             onValueChange={handleSearchInput}
//             placeholder="Search medicine..."
//             className=" truncate"
//           />
//           <CommandList>
//             <CommandEmpty>No medicine found.</CommandEmpty>
//             <CommandGroup>
//               {(searchData?.data || []).map((product: any) => (
//                 <CommandItem
//                   key={product.id}
//                   value={product.name}
//                   onSelect={() => changeSelection(product.id)}
//                 >
//                   <Check
//                     className={cn(
//                       'mr-2 h-4 w-4',
//                       value === product.id ? 'opacity-100' : 'opacity-0',
//                     )}
//                   />
//                   {product.name}
//                 </CommandItem>
//               ))}
//             </CommandGroup>
//           </CommandList>
//         </Command>
//       </PopoverContent>
//     </Popover>
//   );
// }
